import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PortfolioPhoto} from '../../../core/entities/portfolio/portfolio-photo.entity';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public getPortfolio(photographerId: number): Observable<PortfolioPhoto[]> {
    return this.http.get<PortfolioPhoto[]>(`${environment.apiUrl}/marketplace/photographer/${photographerId}/portfolio`);
  }
}
